<template>
<div>
  <div v-html="params"></div>

</div>
</template>

<script>
export default {
    props: {
        params: {
            type: String
        }
    },
}
</script>

<style>

</style>